export class CommerceFileDocumentModel {
  fileName: string;
  extension: string;
  description: string;
  documentType: string;
  created: Date;
  createdBy: string;
  file: string;
  contacts: any []
}
